import {Outlet, useLocation, Link} from "react-router-dom";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {getImageForRoute, getStudentForRoute} from "../../constants/routeImages";
import {ROUTES} from "../../router/config";
import logo from "../../assets/images/logo-rgb.svg";
import logoWhite from "../../assets/images/logo-rgb-white.svg";
import ProgressBar from "../ProgressBar";
import {useRedirectIfComplete} from "../../hooks/useRedirectIfComplete";
import ErrorBoundary from "../ErrorBoundary";
import "./Layout.css";

const Layout = () => {
    useRedirectIfComplete();

    const location = useLocation();
    const {t} = useTranslation();
    const backgroundImage = getImageForRoute(location.pathname);
    const studentInfo = getStudentForRoute(location.pathname);
    const hideProgress = [ROUTES.WELCOME, ROUTES.COMPLETE].includes(location.pathname);

    return (
        <div className='Layout'>
            <div className='Layout-container'>
                <div className='Layout-content'>
                    <div className='Layout-header'>
                        <Link to="/">
                            <img src={logo} alt="USPA Logo" className='Layout-logo'/>
                        </Link>
                    </div>

                    <div className='Layout-main'>
                        <ErrorBoundary>
                            <Outlet/>
                        </ErrorBoundary>
                    </div>
                </div>
                <div className='Layout-imageWrapper'>
                    <Link to="/" className='Layout-logo-wrapper'>
                        <img src={logoWhite} alt="USPA Logo" className='Layout-logo'/>
                    </Link>
                    {!hideProgress && <ProgressBar currentRoute={location.pathname}/>}
                    <div
                        className='Layout-image'
                        style={{backgroundImage: `url(${backgroundImage})`}}
                    />
                    <div className='Layout-image__student'>
                        <Typography component="div" className="Layout-image__student__class">
                            <span className="Layout-image__student__slash diagonal-slash" />
                            {`${t("progress.classOf")}${studentInfo.class}`}
                        </Typography>
                        <Typography component="div" className="Layout-image__student__name">
                            {studentInfo.name}
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
